import { render, staticRenderFns } from "./DashboardAdhesionsList.vue?vue&type=template&id=70fcd9a5&"
import script from "./DashboardAdhesionsList.vue?vue&type=script&lang=js&"
export * from "./DashboardAdhesionsList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAdhesionsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports